import { InlineElements } from './InlineElements'

export const TaskListBlock = ({ tasks }: { tasks: any[] }) => (
    <ul className="task-list">
        {tasks.map((item, index) => (
            <li
                key={index}
                style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-start',
                    gap: '0.5em',
                }}
            >
                <InlineElements contents={item.value} />
            </li>
        ))}
    </ul>
)
